// const apiUrl = 'http://192.168.1.38:5000/api';

// this is hosting 
// const apiUrl = 'http://13.253.240.37:8000/api';

// const apiUrl = 'http://192.168.1.35:8001/api';
//const apiUrl = 'http://192.168.1.103:8001/api';
// const apiUrl = 'https://bs.aalantechsoft.com:8003/api';



// const apiUrl = 'http://192.168.151.27:8000/api';

// const apiUrl = 'http://13.53.212.92:8000/api';

 const apiUrl = 'https://bs.aalantechsoft.com:8003/api';

// const apiUrl = 'https://bs.Skimitarautomation.com:8000/api';

export default apiUrl;